




























import Vue from 'vue';
import Component from 'vue-class-component';
import '@/vue_material/components';

@Component({})
export default class ToolBar extends Vue {
  private sendBugEmail(): void {
    window.open('mailto:projetoarbc@gmail.com?subject=Bug');
  }
}
